import { useContext, useState } from "react"
import { useTranslation } from "react-i18next";
import { ConfirmAlert } from "src/component/confirmAlert";
import { Context } from "src/context";
import { successToaster } from "src/utils";

export type ActionType = "post" | "edit" | "delete"

interface MutateParams {
    apiMethod: (...args: any[]) => Promise<any>;
    actionType: ActionType;
    name: string
    args?: any[];
    id?: string | number;
    body?: any;
    onSuccess?: () => void;
    onError?: () => void;
    customActionTitle?: string;
}

export const useMutation = () => {
    const [isPending, setIsPending] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [isError, setIsError] = useState(false)

    const { setLoading } = useContext(Context)
    const { ToggleReloadTable } = useContext(Context)

    const { t } = useTranslation()

    const mutate = ({ apiMethod, id, body, actionType, customActionTitle, name, onSuccess, onError }: MutateParams) => {
        setIsSuccess(false);
        setIsError(false);

        const args = { post: [body], edit: [id, body], delete: [id] }[actionType];

        ConfirmAlert(` ${customActionTitle ? t(customActionTitle) : t(actionType) + ' ' + t(name)}`,
            () => {
                setLoading((l: number) => l + 1)

                setIsPending(true);
                apiMethod(...args).then((res: any) => {
                    onSuccess?.()
                    successToaster("Operation Done Successfully")
                    ToggleReloadTable(prev => !prev)
                }).catch((_: any) => {
                    onError?.()
                }).finally(() => {
                    setLoading((l: number) => l - 1)
                    setIsPending(false)
                })
            }, () => { })

    }

    return { isError, isPending, isSuccess, mutate }
}